/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateBusinessPartnerMutationRequest,
  UpdateBusinessPartnerMutationResponse,
  UpdateBusinessPartnerPathParams,
} from "../types/UpdateBusinessPartner.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateBusinessPartnerMutationKey = () =>
  [{ url: "/v1/contacts/update-business-partner/:id" }] as const

export type UpdateBusinessPartnerMutationKey = ReturnType<
  typeof updateBusinessPartnerMutationKey
>

/**
 * @summary Update business partner
 * {@link /v1/contacts/update-business-partner/:id}
 */
export async function updateBusinessPartner(
  id: UpdateBusinessPartnerPathParams["id"],
  data: UpdateBusinessPartnerMutationRequest,
  config: Partial<RequestConfig<UpdateBusinessPartnerMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateBusinessPartnerMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateBusinessPartnerMutationRequest
  >({
    method: "PUT",
    url: `/v1/contacts/update-business-partner/${id}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateBusinessPartnerMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateBusinessPartnerMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateBusinessPartnerMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateBusinessPartnerMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateBusinessPartnerPathParams["id"]
      data: UpdateBusinessPartnerMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return updateBusinessPartner(id, data, config)
    },
  })
}

/**
 * @summary Update business partner
 * {@link /v1/contacts/update-business-partner/:id}
 */
export function useUpdateBusinessPartner<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateBusinessPartnerMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        id: UpdateBusinessPartnerPathParams["id"]
        data: UpdateBusinessPartnerMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateBusinessPartnerMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateBusinessPartnerMutationKey()

  const baseOptions = updateBusinessPartnerMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateBusinessPartnerMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateBusinessPartnerPathParams["id"]
      data: UpdateBusinessPartnerMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateBusinessPartnerMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateBusinessPartnerPathParams["id"]
      data: UpdateBusinessPartnerMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateBusinessPartnerMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateBusinessPartnerPathParams["id"]
      data: UpdateBusinessPartnerMutationRequest
    },
    TContext
  >
}
